import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

import Icon from '../icon/Icon';

require('./style.scss');

const Modal = props =>
  props.open ?
    <div className="modal-overlay" onClick={() => props.onClose()}>
      <div className="modal-wrapper">
        <div
          className={Classnames('modal', props.className)}
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-close" onClick={() => props.onClose()}>
            <Icon name="times" />
          </div>

          {props.children}
        </div>
      </div>
    </div> : null;

Modal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

module.exports = Modal;



// WEBPACK FOOTER //
// ./app/components/common/modal/Modal.jsx